var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LookElectornic"},[_c('van-popup',{on:{"click-overlay":_vm.handleClick,"click":_vm.handleClick},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('img',{staticClass:"img",attrs:{"src":_vm.getOcrUrl(_vm.urlImg),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }